// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ProcessExecutionResponse
 */
export interface ProcessExecutionResponse {
  /**
   *
   */
  jobId: string;
  /**
   *
   */
  name?: string;
}

/**
 * Check if a given object implements the ProcessExecutionResponse interface.
 */
export function instanceOfProcessExecutionResponse(
  value: object
): value is ProcessExecutionResponse {
  if (
    (!("jobId" in (value as Record<string, any>)) &&
      !("job_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["jobId"] === undefined &&
      (value as Record<string, any>)["job_id"] === undefined)
  )
    return false;
  return true;
}

export function ProcessExecutionResponseFromJSON(json: any): ProcessExecutionResponse {
  return ProcessExecutionResponseFromJSONTyped(json, false);
}

export function ProcessExecutionResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ProcessExecutionResponse {
  if (json == null) {
    return json;
  }
  return {
    jobId: json["job_id"],
    name: json["name"] == null ? undefined : json["name"],
  };
}

export function ProcessExecutionResponseToJSON(json: any): ProcessExecutionResponse {
  return ProcessExecutionResponseToJSONTyped(json, false);
}

export function ProcessExecutionResponseToJSONTyped(
  value?: ProcessExecutionResponse | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    job_id: value["jobId"],
    name: value["name"],
  };
}
